import React from 'react';
import { Tabs, Tab } from 'react-bootstrap'
import DocumentationAlias from './documentationalias'
import PhotoAlias from './photoalias'
import { useTranslation } from "react-i18next";

function Alias() {

	const {t} = useTranslation('common')

	return (
		<div>
			<h2>
				{t('alias.label')}
            </h2>
            <Tabs>
                <Tab eventKey="configurations" title={t('documentationalias.label')} style={{paddingTop: '10px'}}>
					<DocumentationAlias/>
				</Tab>
                <Tab eventKey="events" title={t('photoalias.label')} style={{paddingTop: '10px'}}>
					<PhotoAlias/>
                </Tab>
			</Tabs>
		</div>
    )
}

export default Alias;